import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useMemo } from 'react';
import { Queries } from '@shared/api';

interface Props {
  channelId?: number;
}

interface ChannelUsers {
  users: MBAPI.ShortUser[];
  loading: boolean;
}

export function useChannelUsers({ channelId }: Props): ChannelUsers {
  const { data, loading } = useQuery<
    MBAPI.ListChannelMembershipsQuery,
    MBAPI.ListChannelMembershipsQueryVariables
  >(Queries.channel.listChannelMemberships, {
    variables: {
      input: {
        channelId: channelId ?? -1,
        onlyAssignableUsers: true,
      },
    },
    skip: isNil(channelId),
  });

  return useMemo(() => {
    return {
      users: data?.listChannelMemberships?.map(({ user }) => user) ?? [],
      loading,
    };
  }, [data?.listChannelMemberships, loading]);
}
